export const iconFontAwesomeShapesCircle = (
	<i className="fa-solid fa-circle"></i>
);
